import {
  faArrowRight,
  faBolt,
  faCheckCircle,
  faLightbulb,
  faSeedling,
  faShieldAlt,
  faTools,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import aboutHero from "../Assets/heroes/about-hero.webp";
import PrimaryHero from "../Components/PrimaryHero";
import SectionHeading from "../Components/SectionHeading";

const simpleValues = [
  {
    icon: faLightbulb,
    title: "Simplicity",
    copy: "We remove extra steps and keep the work easy to understand.",
  },
  {
    icon: faBolt,
    title: "Impact",
    copy: "We focus on changes that make daily work and business easier.",
  },
  {
    icon: faCheckCircle,
    title: "Meaningful",
    copy: "Every feature needs a clear reason and a real user benefit.",
  },
  {
    icon: faTools,
    title: "Practical",
    copy: "Our solutions are built for real conditions, not perfect labs.",
  },
  {
    icon: faShieldAlt,
    title: "Lean",
    copy: "We keep software focused, reliable, and easier to maintain.",
  },
  {
    icon: faSeedling,
    title: "Evolving",
    copy: "We learn from feedback and improve the product over time.",
  },
];

function About() {
  return (
    <div className="primary-page">
      <PrimaryHero
        titleId="about-title"
        icon={faUser}
        kicker="About MileSoft"
        title="A simple software company for real needs."
        description={
          <p>
              MileSoft builds practical digital solutions that simplify life and
              business. We help people turn everyday problems into clear,
              reliable web, mobile, and software products.
          </p>
        }
        imageSrc={aboutHero}
        actions={
          <>
              <Link to="/services" className="btn-ms btn-ms-primary btn-ms-lg">
                View services
                <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
              </Link>
              <Link
                to="/contacts"
                className="btn-ms btn-ms-secondary btn-ms-lg"
              >
                Contact MileSoft
              </Link>
          </>
        }
      />

      <section
        className="section-ms section-ms-soft"
        aria-labelledby="mission-title"
      >
        <div className="section-ms-inner primary-two-column">
          <article className="card-ms">
            <div className="card-ms-body">
              <span className="badge-ms">Our purpose</span>
              <h2 id="mission-title">Make useful technology easier to use.</h2>
              <p>
                We plan, build, and improve software around the people who will
                use it. That means plain language, focused features, and systems
                that support real work.
              </p>
            </div>
          </article>
          <article className="card-ms">
            <div className="card-ms-body">
              <span className="badge-ms">How we work</span>
              <h2>Practical first, product first.</h2>
              <p>
                We start with the problem, shape the smallest useful solution,
                then improve it with feedback. The result should feel clear,
                dependable, and worth using.
              </p>
            </div>
          </article>
        </div>
      </section>

      <section className="section-ms" aria-labelledby="values-title">
        <div className="section-ms-inner">
          <SectionHeading
            titleId="values-title"
            kicker="S.I.M.P.L.E values"
            title="The principles behind each build"
            description={
              <p>
              These values keep our work clear, useful, and aligned with the
              MileSoft promise: Simplifying Life Through Technology.
              </p>
            }
          />
          <div className="primary-card-grid">
            {simpleValues.map((value) => (
              <article className="card-ms primary-info-card" key={value.title}>
                <div className="card-ms-body">
                  <span className="brand-icon" aria-hidden="true">
                    <FontAwesomeIcon icon={value.icon} />
                  </span>
                  <h3>{value.title}</h3>
                  <p>{value.copy}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
